import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isAppLoading
        ? _c(
            VSkeletonLoader,
            _vm._b(
              {
                attrs: {
                  type: "list-item-two-line, list-item-two-line, list-item-two-line",
                },
              },
              "v-skeleton-loader",
              _vm.attrs,
              false
            )
          )
        : _c(
            "div",
            [
              _vm.hasData
                ? _c(
                    VMenu,
                    {
                      attrs: {
                        bottom: "",
                        "close-on-click": "",
                        "allow-overflow": "",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  VBtn,
                                  _vm._g(
                                    _vm._b(
                                      { attrs: { outlined: "" } },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c(VIcon, { staticClass: "mr-2" }, [
                                      _vm._v("mdi-sort"),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$vuetify.lang.t(
                                            "$vuetify.base.sort"
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(_vm.selectedSortOption.title) +
                                        " "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3380398783
                      ),
                    },
                    [
                      _c(
                        VList,
                        [
                          _c(
                            VListItemGroup,
                            {
                              attrs: { color: "primary" },
                              on: { change: _vm.sort },
                              model: {
                                value: _vm.selectedSort,
                                callback: function ($$v) {
                                  _vm.selectedSort = $$v
                                },
                                expression: "selectedSort",
                              },
                            },
                            _vm._l(_vm.sortOptions, function (option, index) {
                              return _c(
                                VListItem,
                                { key: index },
                                [
                                  _c(VListItemTitle, [
                                    _vm._v(_vm._s(option.title)),
                                  ]),
                                ],
                                1
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.products && _vm.products.length > 0
                ? _c(VSelect, {
                    staticClass: "mt-5",
                    attrs: {
                      label: "Choose a product",
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      "item-text": "name",
                      "item-value": "id",
                      items: _vm.productOptions,
                    },
                    on: { change: _vm.changeProduct },
                    model: {
                      value: _vm.selectedProductId,
                      callback: function ($$v) {
                        _vm.selectedProductId = $$v
                      },
                      expression: "selectedProductId",
                    },
                  })
                : _vm._e(),
              _c(VTextField, {
                staticClass: "mb-1 mt-5",
                attrs: {
                  dense: "",
                  clearable: "",
                  outlined: "",
                  label: _vm.$vuetify.lang.t("$vuetify.base.search"),
                  hint: _vm.$vuetify.lang.t(
                    "$vuetify.base.weightToleranceHint"
                  ),
                  "persistent-hint": "",
                  "append-icon": "mdi-magnify",
                },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.filter()
                  },
                  "click:clear": function ($event) {
                    _vm.search = ""
                    _vm.filter()
                  },
                  "click:append": function ($event) {
                    return _vm.filter()
                  },
                  change: function ($event) {
                    return _vm.filter()
                  },
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
              _c(
                "div",
                { staticClass: "d-flex flex-wrap mb-3 mt-2" },
                [
                  _c(
                    VChip,
                    {
                      staticClass: "mr-2 mb-2",
                      attrs: {
                        small: "",
                        color: _vm.availableOnly ? "primary" : "",
                        outlined: !_vm.availableOnly,
                      },
                      on: {
                        click: function ($event) {
                          _vm.activeTab = "search"
                          _vm.availableOnly = !_vm.availableOnly
                          _vm.filter()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t("$vuetify.base.availableOnly")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    VChip,
                    {
                      staticClass: "mr-2 mb-2",
                      attrs: {
                        small: "",
                        color: _vm.searchByDoc ? "primary" : "",
                        outlined: !_vm.searchByDoc,
                      },
                      on: {
                        click: function ($event) {
                          _vm.activeTab = "search"
                          _vm.searchByDoc = !_vm.searchByDoc
                          if (_vm.searchByDoc) _vm.searchByWeight = false
                          _vm.filter()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t(
                              "$vuetify.base.searchByDocument"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    VChip,
                    {
                      staticClass: "mr-2 mb-2",
                      attrs: {
                        small: "",
                        color: _vm.searchByWeight ? "primary" : "",
                        outlined: !_vm.searchByWeight,
                      },
                      on: {
                        click: function ($event) {
                          _vm.activeTab = "search"
                          _vm.searchByWeight = !_vm.searchByWeight
                          if (_vm.searchByWeight) _vm.searchByDoc = false
                          _vm.filter()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t("$vuetify.base.searchByWeight")
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                VTabs,
                {
                  staticClass: "mt-3",
                  attrs: { grow: "" },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(VTab, { attrs: { href: "#search" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$vuetify.lang.t(
                            "$vuetify.worksheet.suggestion.tabSearch"
                          )
                        ) +
                        " "
                    ),
                    _vm.hasData
                      ? _c("span", { staticClass: "text-caption ml-1" }, [
                          _vm._v(
                            " (" +
                              _vm._s(
                                _vm.filteredInventories
                                  ? _vm.filteredInventories.length
                                  : 0
                              ) +
                              ") "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    VTab,
                    { attrs: { href: "#suggestions" } },
                    [
                      _c(VIcon, { attrs: { small: "", left: "" } }, [
                        _vm._v("mdi-lightbulb-on-outline"),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t(
                              "$vuetify.worksheet.suggestion.tabSuggestions"
                            )
                          ) +
                          " "
                      ),
                      _vm.suggestedItems
                        ? _c("span", { staticClass: "text-caption ml-1" }, [
                            _vm._v(
                              " (" + _vm._s(_vm.suggestedItems.length) + ") "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VTabsItems,
                {
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    VTabItem,
                    { attrs: { value: "search" } },
                    [
                      _vm.hasData && _vm.dates && _vm.dates.length > 4
                        ? _c(VRangeSlider, {
                            key: _vm.selectedProductId,
                            staticClass: "align-center mt-4",
                            attrs: {
                              max: _vm.maxDate,
                              min: _vm.minDate,
                              "hide-details": "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.filter()
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "prepend",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "text-caption",
                                          staticStyle: {
                                            "white-space": "nowrap",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("formatDateYear")(
                                                  _vm.dates[_vm.dateRange[0]]
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "append",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "text-caption",
                                          staticStyle: {
                                            "white-space": "nowrap",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("formatDateYear")(
                                                  _vm.dates[
                                                    _vm.dateRange[1] - 1
                                                  ]
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              1110156834
                            ),
                            model: {
                              value: _vm.dateRange,
                              callback: function ($$v) {
                                _vm.dateRange = $$v
                              },
                              expression: "dateRange",
                            },
                          })
                        : _vm._e(),
                      _vm.hasData
                        ? _c(
                            VList,
                            [
                              _vm.selectedProduct
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "text-overline text-center",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.selectedProduct.name) +
                                          " - " +
                                          _vm._s(
                                            _vm.$vuetify.lang.t(
                                              "$vuetify.worksheet.xAvailable",
                                              _vm.filteredInventories
                                                ? _vm.filteredInventories.length
                                                : 0
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                VListItemGroup,
                                { attrs: { color: "primary" } },
                                [
                                  _vm._l(
                                    _vm.filteredInventories,
                                    function (inventory, index) {
                                      return [
                                        _c(
                                          VListItem,
                                          {
                                            key: inventory.id,
                                            staticClass: "pl-0 pl-sm-2 pl-md-4",
                                            attrs: {
                                              disabled:
                                                inventory.quantityAvailable -
                                                  inventory.reservedQuantity <=
                                                0,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectedInventoryChanged(
                                                  inventory
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              VListItemIcon,
                                              { staticClass: "mr-2 mr-md-4" },
                                              [_vm._v(_vm._s(index + 1) + ".")]
                                            ),
                                            _c(
                                              VListItemContent,
                                              [
                                                _c(VListItemTitle, [
                                                  _c(
                                                    "div",
                                                    { staticClass: "d-flex" },
                                                    [
                                                      _vm.products &&
                                                      _vm.products.length > 0
                                                        ? _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                inventory.productName
                                                              )
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                      _vm.products &&
                                                      _vm.products.length > 0
                                                        ? _c(VDivider, {
                                                            staticClass: "mx-2",
                                                            attrs: {
                                                              vertical: "",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatNumber"
                                                              )(
                                                                inventory.quantityAvailable -
                                                                  inventory.reservedQuantity
                                                              )
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.selectedProduct
                                                                ? _vm
                                                                    .selectedProduct
                                                                    .measureWeight
                                                                : ""
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                  inventory.reserved
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-caption",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " (" +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "formatNumber"
                                                                )(
                                                                  inventory.reservedQuantity
                                                                )
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.selectedProduct
                                                                  ? _vm
                                                                      .selectedProduct
                                                                      .measureWeight
                                                                  : ""
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.$vuetify.lang.t(
                                                                  "$vuetify.worksheet.reserved"
                                                                )
                                                              ) +
                                                              ") "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  inventory.unitDetails &&
                                                  inventory.unitDetails.length >
                                                    0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-caption font-weight-light",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " (" +
                                                              _vm._s(
                                                                _vm.$vuetify.lang.t(
                                                                  "$vuetify.worksheet.xAvailable",
                                                                  inventory.unitAvailable
                                                                )
                                                              ) +
                                                              ")"
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  inventory.unitDetails &&
                                                  inventory.unitDetails.length >
                                                    0 &&
                                                  inventory.reservedByWorksheets &&
                                                  inventory.reservedByWorksheets
                                                    .length > 0
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-caption font-weight-light",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " (" +
                                                              _vm._s(
                                                                _vm.$vuetify.lang.t(
                                                                  "$vuetify.worksheet.xReserved",
                                                                  inventory
                                                                    .reservedByWorksheets
                                                                    .length
                                                                )
                                                              ) +
                                                              ") "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]),
                                                _c(VListItemSubtitle, [
                                                  _c(
                                                    "div",
                                                    { staticClass: "d-flex" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatDateYear"
                                                            )(
                                                              inventory.stockTime
                                                            )
                                                          ) +
                                                          " (Doc #: " +
                                                          _vm._s(
                                                            inventory.documentNumber
                                                          ) +
                                                          " / ID: " +
                                                          _vm._s(inventory.id) +
                                                          ") "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._l(
                                          _vm.matchingUnitsFor(inventory),
                                          function (unit) {
                                            return _c(
                                              VListItem,
                                              {
                                                key:
                                                  inventory.id +
                                                  "-u-" +
                                                  unit.id,
                                                staticClass:
                                                  "pl-8 pl-sm-10 pl-md-12",
                                                attrs: { dense: "" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.selectMatchedUnit(
                                                      inventory,
                                                      unit
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VListItemIcon,
                                                  {
                                                    staticClass: "mr-2 mr-md-4",
                                                  },
                                                  [
                                                    _c(
                                                      VIcon,
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color: "primary",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-package-variant"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  VListItemContent,
                                                  { staticClass: "py-1" },
                                                  [
                                                    _c(
                                                      VListItemTitle,
                                                      {
                                                        staticClass:
                                                          "text-body-2",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              unit.code
                                                                ? unit.code +
                                                                    " · "
                                                                : ""
                                                            ) +
                                                            " "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "font-weight-bold",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatNumber"
                                                                  )(
                                                                    unit.amountPerUnit
                                                                  )
                                                                ) +
                                                                " " +
                                                                _vm._s(
                                                                  _vm.selectedProduct
                                                                    ? _vm
                                                                        .selectedProduct
                                                                        .measureWeight
                                                                    : ""
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-caption font-weight-light ml-2",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " (" +
                                                                _vm._s(
                                                                  _vm.$vuetify.lang.t(
                                                                    "$vuetify.base.unit"
                                                                  )
                                                                ) +
                                                                " ID: " +
                                                                _vm._s(
                                                                  unit.id
                                                                ) +
                                                                ") "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "my-8 text-center text--secondary" },
                            [_vm._v("No data found")]
                          ),
                    ],
                    1
                  ),
                  _c(VTabItem, { attrs: { value: "suggestions" } }, [
                    _vm.suggestedItems && _vm.suggestedItems.length > 0
                      ? _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-caption text--secondary text-center mt-3 mb-1",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$vuetify.lang.t(
                                        "$vuetify.worksheet.suggestion.subtitle"
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              VList,
                              [
                                _c(
                                  VListItemGroup,
                                  { attrs: { color: "primary" } },
                                  _vm._l(_vm.suggestedItems, function (s, idx) {
                                    return _c(
                                      VListItem,
                                      {
                                        key: "sugg-" + s.inventory.id,
                                        staticClass: "pl-0 pl-sm-2 pl-md-4",
                                        attrs: {
                                          disabled:
                                            s.inventory.quantityAvailable -
                                              (s.inventory.reservedQuantity ||
                                                0) <=
                                            0,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onSuggestedClick(s)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          VListItemIcon,
                                          { staticClass: "mr-2 mr-md-4" },
                                          [_vm._v(_vm._s(idx + 1) + ".")]
                                        ),
                                        _c(
                                          VListItemContent,
                                          [
                                            _c(VListItemTitle, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-center flex-wrap",
                                                },
                                                [
                                                  _vm.products &&
                                                  _vm.products.length > 0
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            s.inventory
                                                              .productName
                                                          )
                                                        ),
                                                      ])
                                                    : _vm._e(),
                                                  _vm.products &&
                                                  _vm.products.length > 0
                                                    ? _c(VDivider, {
                                                        staticClass: "mx-2",
                                                        attrs: { vertical: "" },
                                                      })
                                                    : _vm._e(),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatNumber"
                                                            )(
                                                              s.inventory
                                                                .quantityAvailable
                                                            )
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.selectedProduct
                                                              ? _vm
                                                                  .selectedProduct
                                                                  .measureWeight
                                                              : ""
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "mt-1 d-flex flex-wrap",
                                                },
                                                _vm._l(
                                                  s.reasons || [],
                                                  function (r) {
                                                    return _c(
                                                      VChip,
                                                      {
                                                        key:
                                                          "sugg-" +
                                                          s.inventory.id +
                                                          "-r-" +
                                                          r.code,
                                                        staticClass:
                                                          "mr-1 mb-1",
                                                        attrs: {
                                                          "x-small": "",
                                                          color:
                                                            r.code ===
                                                            "LIMITED_HISTORY"
                                                              ? "grey lighten-2"
                                                              : "primary lighten-4",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.reasonLabel(
                                                                r.code
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                            ]),
                                            _c(VListItemSubtitle, [
                                              _c(
                                                "div",
                                                { staticClass: "d-flex" },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatDateYear"
                                                        )(s.inventory.stockTime)
                                                      ) +
                                                      " (Doc #: " +
                                                      _vm._s(
                                                        s.inventory
                                                          .documentNumber
                                                      ) +
                                                      " / ID: " +
                                                      _vm._s(s.inventory.id) +
                                                      ") "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "my-8 text-center text--secondary" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$vuetify.lang.t(
                                    "$vuetify.worksheet.suggestion.emptyState"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
      _c(
        VBottomSheet,
        {
          attrs: { scrollable: "" },
          model: {
            value: _vm.showUnits,
            callback: function ($$v) {
              _vm.showUnits = $$v
            },
            expression: "showUnits",
          },
        },
        [
          _c(
            VSheet,
            {
              staticClass: "text-center",
              staticStyle: { "max-height": "380px", overflow: "scroll" },
            },
            [
              _c(
                VBtn,
                {
                  staticClass: "mt-6",
                  attrs: { text: "", color: "red" },
                  on: {
                    click: function ($event) {
                      _vm.showUnits = false
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$vuetify.lang.t("$vuetify.close")) + " "
                  ),
                ]
              ),
              _c(VDivider),
              _c(
                "div",
                { staticClass: "mx-6" },
                [
                  _vm.units && _vm.units.length > 5
                    ? _c(VTextField, {
                        attrs: {
                          dense: "",
                          clearable: "",
                          outlined: "",
                          "hide-details": "",
                          label: "Search Unit",
                          "append-icon": "mdi-magnify",
                        },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.filterUnit()
                          },
                          "click:clear": function ($event) {
                            _vm.searchUnit = ""
                            _vm.filterUnit()
                          },
                          "click:append": function ($event) {
                            return _vm.filterUnit()
                          },
                          change: function ($event) {
                            return _vm.filterUnit()
                          },
                        },
                        model: {
                          value: _vm.searchUnit,
                          callback: function ($$v) {
                            _vm.searchUnit = $$v
                          },
                          expression: "searchUnit",
                        },
                      })
                    : _vm._e(),
                  _c(VSwitch, {
                    attrs: {
                      "hide-details": "",
                      dense: "",
                      label: "Show used",
                    },
                    on: {
                      change: function ($event) {
                        return _vm.filterUnit()
                      },
                    },
                    model: {
                      value: _vm.showUsed,
                      callback: function ($$v) {
                        _vm.showUsed = $$v
                      },
                      expression: "showUsed",
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "text-overline" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$vuetify.lang.t("$vuetify.worksheet.chooseUnit")
                    ) +
                    " "
                ),
              ]),
              _vm.selectedInventory
                ? _c(
                    VList,
                    [
                      _c(
                        VListItemGroup,
                        _vm._l(_vm.filteredUnits, function (unit, unitIndex) {
                          return _c(
                            VListItem,
                            {
                              key: unit.id,
                              attrs: {
                                disabled:
                                  unit.reserved || unit.status == "Used",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.selectedInventoryUnitChanged(unit)
                                },
                              },
                            },
                            [
                              _c(
                                VListItemContent,
                                [
                                  _c(VListItemTitle, [
                                    _vm._v(
                                      " " +
                                        _vm._s(unitIndex + 1) +
                                        ". " +
                                        _vm._s(unit.code) +
                                        " "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold ml-5" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              unit.amountPerUnit
                                            )
                                          ) +
                                            " " +
                                            _vm._s(unit.unitMeasure)
                                        ),
                                      ]
                                    ),
                                    unit.status == "Used"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-caption font-weight-light",
                                          },
                                          [
                                            _vm._v(
                                              " (" +
                                                _vm._s(
                                                  _vm.$vuetify.lang.t(
                                                    "$vuetify.worksheet.used"
                                                  )
                                                ) +
                                                ")"
                                            ),
                                          ]
                                        )
                                      : unit.reserved
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "text-caption font-weight-light",
                                          },
                                          [
                                            _vm._v(
                                              " (" +
                                                _vm._s(
                                                  _vm.$vuetify.lang.t(
                                                    "$vuetify.worksheet.reserved"
                                                  )
                                                ) +
                                                ")"
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                  unit.description
                                    ? _c(VListItemSubtitle, [
                                        _vm._v(
                                          " " + _vm._s(unit.description) + " "
                                        ),
                                      ])
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }